(() => {
  'use strict';
  const node = document.querySelector('[data-minty-brand-follow-copy]');
  if (!node) return;
  let labels;
  try { labels = JSON.parse(node.textContent); } catch (_) { return; }
  const wraps = [...document.querySelectorAll('.brand-page .mt-follow[data-follow-type="brand"]')];
  const text = (wrap, key) => String(labels[key] || '').replaceAll('__BRAND__', wrap.dataset.followLabel || '');
  for (const wrap of wraps) {
    const hint = wrap.querySelector('.mt-follow-hint');
    const value = wrap.querySelector('.mt-follow-auth-panel > p');
    if (hint) hint.textContent = text(wrap, 'hint');
    if (value) value.textContent = text(wrap, 'value');
    const status = wrap.querySelector('.mt-follow-status');
    const button = wrap.querySelector('button.mt-follow-btn');
    if (status && button && !button.disabled && /^(You[’']re following |You are following |Save )/.test(status.textContent.trim())) {
      status.textContent = text(wrap, button.getAttribute('aria-pressed') === 'true' ? 'saved' : 'unsaved');
    }
  }
  window.addEventListener('minty:follow-change', event => {
    const change = event.detail;
    if (!change || change.type !== 'brand' || typeof change.following !== 'boolean') return;
    for (const wrap of wraps) {
      if (wrap.dataset.followValue !== String(change.value)) continue;
      const status = wrap.querySelector('.mt-follow-status');
      if (status) status.textContent = text(wrap, change.following ? 'saved' : 'unsaved');
    }
  });
})();
